import { Box, Typography } from "@mui/material";
import React from "react";
import TestimonialCard from "./TestimonialCard";
import Banner from "./Banner";

const ChooseUs = () => {
  return (
    <Box sx={{ mt: { xs: 2, xl: "100px" }, textAlign: "center" }}>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 400,
          fontSize: { xl: "60px" },
          fontFamily: "DM Serif Text",
          lineHeight: { xl: "82.26px" },
          textAlign: "center",
        }}
      >
        Why Choose SHG for Your Next Locum Role?
      </Typography>
      <Box
        sx={{
          mt: { xs: "2rem", xl: "63px" },
          display: "flex",
          justifyContent: "left !important",
          alignItems: "center !important",
          flexWrap: "wrap",
          gap: 2,
          pl: { md: "1.5rem !important" },
        }}
      >
        <TestimonialCard />
        <TestimonialCard />
        <TestimonialCard />
        <TestimonialCard />
        <TestimonialCard />
        <TestimonialCard />
      </Box>
      <Banner />
    </Box>
  );
};

export default ChooseUs;
